import { IScoreEditorThis } from "../../../../../common/types";
import { deselectNote } from "./deselectNote";

export const handleSelect = function (this: IScoreEditorThis, barIndex: number, noteIndex: number, activeVoice: number = 0) {
  this.deselectNote = deselectNote.bind(this);
  this.setState(
      {
          activeVoice: +activeVoice,
          selectedNote: { bar: barIndex, note: noteIndex, lyric: false },
          restMode: this.state.score["bars" + (activeVoice || "")][barIndex].notes[noteIndex].r,
      },
      () => {
          if (!this.hasClickEventListener) {
              this.hasClickEventListener = true;
              this.scoreRef.addEventListener("click", this.deselectNote, true);
          }
      }
  );
};